import { useEffect, useState } from 'react';
import { permissionState, requestPermission } from '../../lib/telephony/notifications';

/**
 * Banner shown inside the minimized widget when notifications are in `default`
 * state. Disappears after the user grants or denies — no pushy popup on load.
 */
export function NotificationPermissionBanner() {
  const [state, setState] = useState<NotificationPermission | 'unsupported'>(() =>
    permissionState(),
  );

  useEffect(() => {
    setState(permissionState());
  }, []);

  if (state !== 'default') return null;

  async function handleClick() {
    const next = await requestPermission();
    setState(next);
  }

  return (
    <div className="px-3 py-2 bg-indigo-50 border-b border-indigo-100 text-xs flex items-center gap-2">
      <span className="flex-1 text-indigo-900">
        Laat browser je waarschuwen bij inkomende gesprekken.
      </span>
      <button
        type="button"
        onClick={handleClick}
        className="px-2 py-1 rounded bg-indigo-500 text-white hover:bg-indigo-600 text-[11px] font-medium"
      >
        Toestaan
      </button>
    </div>
  );
}
